// Seleziona tutto il contenuto del campo al focus, così digitando si sovrascrive il valore (es. "0,00").
// Safari annulla la selezione al mouseup del click che ha dato il focus: lo blocchiamo una sola volta.
const selectAllOnFocus = (e) => {
  const input = e.target;
  input.select();
  input.addEventListener("mouseup", (ev) => ev.preventDefault(), {
    once: true,
  });
};

export default selectAllOnFocus;
